import { ChipProps } from '@mui/material';

export type WorkflowProgressValue = 'all' | 'draft' | 'submitted' | 'completed';

export type WorkflowQuickFilter = {
  label: string;
  value: WorkflowProgressValue;
};

export const WORKFLOW_PROGRESS_FILTERS: WorkflowQuickFilter[] = [
  { label: 'View All', value: 'all' },
  { label: 'In Draft', value: 'draft' },
  { label: 'Submitted', value: 'submitted' },
  { label: 'Complete', value: 'completed' },
];

const COMPLETED_KEYWORDS = ['approved', 'rejected', 'completed'];
const SUBMITTED_KEYWORDS = ['review', 'submitted', 'progress'];

export const formatWorkflowStatus = (state?: string | null) => {
  if (!state || state.trim().length === 0) {
    return 'No Workflow';
  }
  return state;
};

export const getWorkflowProgress = (
  state?: string | null,
): WorkflowProgressValue => {
  if (!state || state.toLowerCase().includes('pending') || state.toLowerCase().includes('draft')) {
    return 'draft';
  }

  const lowered = state.toLowerCase();
  if (COMPLETED_KEYWORDS.some((keyword) => lowered.includes(keyword))) {
    return 'completed';
  }
  if (SUBMITTED_KEYWORDS.some((keyword) => lowered.includes(keyword))) {
    return 'submitted';
  }
  return 'submitted';
};

export const getWorkflowProgressLabel = (progress: WorkflowProgressValue) => {
  switch (progress) {
    case 'draft':
      return 'In Draft';
    case 'submitted':
      return 'Submitted';
    case 'completed':
      return 'Completed';
    default:
      return 'View All';
  }
};

export const getStatusChipColor = (
  state?: string | null,
): ChipProps['color'] => {
  const lowered = state?.toLowerCase() ?? '';
  if (lowered.includes('approved')) return 'success';
  if (lowered.includes('rejected')) return 'error';
  if (lowered.includes('review')) return 'warning';
  return 'default';
};

export const getProgressChipColor = (
  progress: WorkflowProgressValue,
): ChipProps['color'] => {
  switch (progress) {
    case 'draft':
      return 'default';
    case 'submitted':
      return 'warning';
    case 'completed':
      return 'success';
    default:
      return 'default';
  }
};
